import Vue from "vue";
import Router from "vue-router";
import Overview from "../pages/Overview.vue";
import Illustration from "../pages/Illustration.vue";
import ProjectWrapper from "../pages/ProjectWrapper.vue";

Vue.use(Router);

export default new Router({
  // mode: "history",
  base: 'https://lucas-builds.netlify.app/',
  routes: [
    {
      path: "/about",
      name: "about",
      component: () => import("../pages/About.vue")
    },
    {
      path: "/projects/:slug",
      name: "project",
      props: true, 
      component: ProjectWrapper
    },
    {
      path: "/overview",
      name: "overview",
      props: true, 
      component: Overview
    },
    {
      path: "/illustration",
      name: "illustration",
      props: true, 
      component: Illustration
    },
    {
      path: "/resume",
      name: "resume",
      props: true, 
      component: () => import("../pages/Resume.vue")
    },
    {
      path: "/*",
      redirect: to => '/overview',
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});
